<template>
    <div class="pop" v-show="show"  @click.stop='_=>{}'>
        <div class="box">
            <div class="title">
                {{title}}
                <span @click="show = false" class="closeBtn"></span>
            </div>
            <div class="wrap">
                <div style="font-weight: normal;margin-bottom: 10px;">
                    <a class="link" @click="argumentShow = !argumentShow" style="margin-left: 15px;">专业/非专业定义</a>
                    <div class="argument" :class="{show: argumentShow}">
                        <div  style='padding: 5px 10px;'>
                            <h5 style='font-size: 14px;margin-top: 0;'>Non-Professional Subscriber：</h5>
                            <p>Any natural person who is NOT: </p>
                            <p>(a) registered or qualified in any capacity with the SEC, the Commodities Futures Trading Commission, any state securities agency, any securities exchange or association or any commodities or futures contract market orassociation;</p>
                            <p>(b) engaged as an "investment advisor" as that term is defined inSection 202(a)(11) of the Investment Advisors Act of 1940 (whether or not registered or qualified under that Act);or (c) employed by a bank or other organization exempt from registration under federal or state securities laws to perform functions that would require registration or qualification if such functions were performed for an organization notsoexempt.</p>
                            <h5>Professional Subscriber：</h5>
                            <p>All other persons who do not meet the definition of Non-Professional User.</p>
                        </div>
                    </div>
                </div>
                <div style="background-color: #f9f9f9;margin-bottom: 10px;padding: 5px 15px;">
                    <div class="point_left">
                        <label style="width: 90px;display: inline-block;">购买人：</label>
                        <div class="ratio_group" style="display: inline-block;">
                            <label style="margin-right: 10px;" :class="{active: user == 0}" @click="user = 0; tip = false">
                                <i></i> 个人 
                            </label>
                            <label :class="{active: user == 1}"  @click="user = 1; tip = false">
                                <i></i> 机构 
                            </label>
                        </div>
                    </div>
                </div>
                <div style="background-color: #f9f9f9;margin-bottom: 10px;padding: 5px 15px;">
                    <div class="point_left">
                        <label style="width: 90px;display: inline-block;">购买人职业：</label>
                        <el-select v-model="job" placeholder="———— 请选择 ————" size="mini" class="job_selector" popper-class="us_stock_job">
                            <el-option
                                v-for="(item, index) in jobList"
                                :key="index"
                                :label="item"
                                :value="index"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="background-color: #f9f9f9;padding: 5px 15px;">
                    <div class="point_left">请根据实际情况回答以下5个问题：</div>
                    
                    <div class="selectItem" @click="choose(item,index)"
                        v-for="(item,index) in questionList" :key="index">
                        <h4>{{ item.question }}</h4>
                        <p style="padding-left: 6px;">{{ item.introduce }}</p>
                        <div class="ratio_group" style="padding-left: 12px;">
                            <label style="margin-right: 10px;" :class="{active: item.answer === 1}" @click="item.answer = 1">
                                <i></i> 是 
                            </label>
                            <label :class="{active: item.answer === 0}"  @click="item.answer = 0">
                                <i></i> 否 
                            </label>
                        </div>
                        
                    </div>
                </div>
                <!-- <div class="result" v-show="showResult">经判断您属于{{ isMajor ? '' : '非' }}专业用户，对应的服务价格为{{ isMajor ? majorPrice : price }}元/年</div> -->
                <div class="tips" v-show='tip'>{{tipTxt}}</div>
                <button class="roger" :class="{disabled: btnDisabled}" @click="close">提交</button>
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'popselect',
        data: () => ({
            show: true,
            questionList: [],
            tip: false,
            argumentShow: false,
            user: -1,
            jobList: [
                '企业普通职员（非金融相关）',
                '自由职业者',
                '其它职业',
                '无业',
                '证券 / 期货交易员',
                '投资顾问',
                '资产管理人',
                '金融机构分析师',
                '企业投融资专员',
                '金融监管机构相关职员',
                '大宗商品贸易风控专员',
                '私募 / 公募基金从业人员'
            ],
            job: null
        }),
        props: {
            list: {
                type: Array,
                default: () => ([])
            },
            price: String,
            majorPrice: String,
            isjg: {
                type: Boolean,
                default: false    
            },
            title: {
                default: '请回答以下问题以确认购买人身份',
                type: String
            },
            content: {
                default: '请根据您的实际情况选择以下5问题答案，以便我们为您匹配对应的服务方案：',
                type: String
            },
            confirmCall: {
                default: () => {},
                type: Function
            }
        },
        methods: {
            close() {
                if (this.btnDisabled) {
                    this.tip = true
                    return
                }
                this.show = false
                this.confirmCall && this.confirmCall(this.isMajor ? 1 : 0, (this.user==1?"机构":"个人")+","+this.questionList.map(v => v.question + '  ' + (v.answer == 1 ? '是' : '否')).join(','), this.jobList[this.job], this.user)
            },
            choose(item, index) {
                this.tip = false
            }
        },
        watch: {
            list: {
                handler(val) {
                    if (!val || val.length <= 0) return
                    this.questionList = val.map(v => ({
                        ...v,
                        answer: null
                    }))
                },
                immediate: true
            },
            isjg: {
                handler (val) {
                    if (val) {
                        // this.user = 1
                    }
                },
                immediate: true
            }
        },
        computed: {
            isMajor () {
                return this.questionList.some(v => v.answer == 1) || this.job > 3 || this.user == 1
            },
            showResult () {
                return this.questionList.some(v => v.answer !== null) || this.job !== null || this.user > -1
            },
            btnDisabled () {
                return this.questionList.some(v => v.answer === null) || this.job === null || this.user == -1
            },
            tipTxt () {
                if (this.user == -1) return '请选择购买人'
                if (this.job === null) return '请选择购买人职业'
                return '请完成所有问题'
            }
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
    .job_selector >>> .el-input .el-input__inner {
        font-size: 14px;
    }
    .point_left {
        position: relative;
    }
    .point_left::before {
        content: '';
        position: absolute;
        left: -10px;
        top: 11px;
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: #7c7c7c;
    }
    .tips {
        color: #97253F;
        margin-top: 5px;
        margin-left: 20px;
    }
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .box {
        width: 620px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .title {
        height: 34px;
        background: url(../assets/image/confirm_title_bg.jpg) repeat;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
        position: relative;
    }

    .link {
        text-decoration: underline;
        font-weight: normal;
        color: rgb(73, 132, 212);
    }
    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 30px 60px;
        color: #7c7c7c;
        font-weight: bolder;
        font-size: 14px;
        line-height: 24px;
    }
    .argument {
        color: #7c7c7c;
        max-height: 200px;
        height: 0;
        overflow: hidden;
        overflow-y: auto;
        background: #e0edfd;
        margin-bottom: 10px;
        transition: height .3s;
    }
    .argument >>> h5 {
        font-size: 14px;
        margin-bottom: 5px;
    }
    .argument >>> p {
        font-weight: normal;
    }
    .argument.show {
        height: 200px;
    }
    .roger {
        color: #fff;
        font-weight: bolder;
        background: rgb(73, 132, 212);
        padding: 5px 28px;
        cursor: pointer;
        display: block;
        width: 96px;
        zoom: 1;
        margin: 0 auto;
        border: 0;
        margin-top: 25px;
        outline: 0;
    }

    .roger.disabled {
        background-color: rgb(147, 171, 206);
    }
    .selectItem {
        cursor: default;
        padding-bottom: 10px;
    }
    .selectItem p {
        font-weight: normal;
        margin-bottom: 5px;
        font-size: 13px;
    }
    .selectItem h4{
        padding: 0;
        margin: 0;
    }
    .closeBtn {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 0;
        top: 0;
        background: url(../assets/image/close.png) no-repeat center;
        background-size: 12px;
        cursor: pointer;
    }
    .ratio_group label i {
        display: inline-block;
        width: 16px;
        height: 16px;
        box-sizing: border-box;
        border-radius: 100%;
        border: 1px solid #7c7c7c;
        vertical-align: middle;
        position: relative;
        top: -1px;
    }
    .ratio_group label.active i{
        background-color: rgb(73, 132, 212);
        border-color: rgb(73, 132, 212);
        position: relative;
    }
    .ratio_group label.active i::before {
        content: '';
        display: block;
        width: 5px;
        height: 2px;
        background-color: white;
        transform: rotate(45deg);
        left: 2px;
        top: 8px;
        position: absolute;
    }
    .ratio_group label.active i::after {
        content: '';
        display: block;
        width: 10px;
        height: 2px;
        background-color: white;
        transform: rotate(-60deg);
        left: 3px;
        top: 6px;
        position: absolute;
    }
    .result {
        border-top: 1px solid #aaa;
        padding-top: 10px;
        font-weight: normal;
        margin-top: 5px;
    }
</style>